import React from "react";
import RSelect from "react-select";

const Select = ({
  name,
  value,
  options,
  onChange,
  styles,
  placeholder,
  components,
  isLoading = false,
  isClearable = true,
  isSearchable = false,
  isDisabled = false,
  isMulti = false,
}) => {
  const SelectStyle = {
    control: (base, state) => ({
      ...base,
      backgroundColor: state.isDisabled ? "#e9ecef" : "white",
      color: "#495057",
      cursor: state.isDisabled ? "not-allowed" : "default",
      border: "1px solid #ced4da",
      ...styles?.control,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#126696"
        : state.isFocused
          ? "#d8e7f0"
          : "inherit",
      ...styles?.option,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };

  return (
    <RSelect
      name={name}
      value={value}
      options={options}
      onChange={onChange}
      styles={SelectStyle}
      isMulti={isMulti}
      isLoading={isLoading}
      placeholder={placeholder}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      isClearable={isClearable}
      isSearchable={isSearchable}
      isDisabled={isDisabled}
      closeMenuOnSelect
      components={components}
    />
  );
};

export default Select;
